import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { Observable } from 'rxjs';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-delete-user-for-customer-dialog-content',
  templateUrl: './delete-user-for-customer-dialog-content.component.html',
  styleUrls: ['./delete-user-for-customer-dialog-content.component.scss'],
  providers: [FormService]
})
export class DeleteUserForCustomerDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteUserForCustomerDialogContentComponent';

  public form: UntypedFormGroup;
  @Input() private customerId: number;
  @Input() private userId: string;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private usersService: UsersService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
    });
  }

  async onSubmit(formValue) {
    try {
      const isMasterUser = await this.usersService.checkIfMasterUser(this.userId).toPromise();

      if (isMasterUser) {
        this.deleteMasterUser();
      } else {
        this.deleteUser();
      }
    } catch (error) {
      this.toastService.error($localize`:@@DeletedDialogErrorHeader:Konto konnte nicht gelöscht werden.`);
    }
  }

  deleteUser() {
    this.usersService.deleteEntity(this.userId).subscribe(result => {
      this.toastService.success($localize`:@@DeletedDialogSuccessHeader:Benutzer wurde erfolgreich gelöscht.`);
      this.activeModal.close({ success: true, deleteMasterUser: false });
    }, error => {
      this.toastService.error($localize`:@@DeletedDialogErrorHeader:Benutzer konnte nicht gelöscht werden.`);
      this.activeModal.close({ success: false, error: error });
    });
  }
  deleteMasterUser() {
    this.usersService.deleteMasterUserOfCustomer(this.customerId).subscribe(result => {
      this.toastService.success($localize`:@@DeletedDialogSuccessHeader:Kunde wurde erfolgreich gelöscht.`);
      this.activeModal.close({ success: true, deleteMasterUser: true });

    }, error => {
      this.toastService.error($localize`:@@DeletedDialogErrorHeader:Kunde konnte nicht gelöscht werden.`);
      this.messageService.setError(error);
    });
  }
}

function firstValueFrom(arg0: Observable<boolean>) {
  throw new Error('Function not implemented.');
}
